export const BASE_URL = process.env.VUE_APP_BASE_URL;
export const BASE_URL_ACTIVITIES = BASE_URL + "/Activities";
export const BASE_URL_STANDARDS_BOOK = BASE_URL + "/StandardsBook";
export const BASE_URL_TRADE_POINTS = BASE_URL + "/TradePoints";
export const BASE_URL_PHOTOS = BASE_URL + "/Photos";
export const BASE_URL_USERS = BASE_URL + "/Users";
export const BASE_URL_AUDITS = BASE_URL + "/Audits";

export const BASE_URL_MAYTG = process.env.VUE_APP_BASE_URL_MAYTG;

export default {

    Client: {
        Audit: {
            GetChangeStatus: BASE_URL + "/Client/AuditV2/ChangeStatus?id=",
            

            PostUpdateComment: BASE_URL_AUDITS + "/Client/UpdateComment",
            PostAddTradePoint: BASE_URL_AUDITS + "/Client/AddTradePoint",

            PostCreate: BASE_URL_AUDITS + "/Client/Create",
            PostDelete: BASE_URL_AUDITS + "/Client/Delete",
            PostComplete: BASE_URL_AUDITS + "/Client/Complete",
            PostSend: BASE_URL_AUDITS + "/Client/Send",

            Get: BASE_URL_AUDITS + "/Client/Info",
            GetDaxUsers: BASE_URL_USERS + "/Mobile/DaxUsers",
        },

        Activities: {
            GetTags: BASE_URL_ACTIVITIES + "/Client/Tags"
        },

        Feed: {
            PostDelete: BASE_URL_AUDITS + "/Client/Feed/Delete",
            GetAll: BASE_URL_AUDITS + "/Client/Feed"
        },

        Form: {
            PostQuestion: BASE_URL_AUDITS + "/Client/Forms/Question",
            PostUpdateComment: BASE_URL_AUDITS + "/Client/Forms/UpdateComment",
            PostDelete: BASE_URL_AUDITS + "/Client/Forms/Delete",
            PostComplete: BASE_URL_AUDITS + "/Client/Forms/Complete",

            Get: BASE_URL_AUDITS + "/Client/Forms/Info",
            GetQuestion: BASE_URL_AUDITS + "/Client/Forms/Question",

           
            PostConfirmMagnit: BASE_URL_AUDITS + "/Client/Forms/ConfirmMagnit"        
            
            
            // GetOpen: BASE_URL + "Client/Forms/Open",            
           
            // GetContacts: BASE_URL + "Client/Forms/Contacts",
            // GetAeps: BASE_URL + "Client/Forms/GetAeps",
            // GetCreateTask: BASE_URL + "Client/Forms/CreateTask",            
            // GetCompleteTask: BASE_URL + "Client/Forms/CompleteTask"         
        },

        Gallery: {
            PostUpdate: BASE_URL_AUDITS + "/Client/Gallery/Update",
            PostDelete: BASE_URL_AUDITS + "/Client/Gallery/Delete",
            
            GetGallery: BASE_URL_AUDITS + "/Client/Gallery"
        },

        Help: {
            Get: BASE_URL + "/Client/Help",
            GetDependency: BASE_URL_STANDARDS_BOOK + "/mobile"
        },

        TradePoints: {
            PostUpdate: BASE_URL + "/Client/TradePoints/Update",
            
            PostFilter: BASE_URL_TRADE_POINTS + "/Client/Filter",
            Get: BASE_URL_TRADE_POINTS + "/Client/Info",
            GetCheckUser: BASE_URL_TRADE_POINTS + "/Client/CheckUser",
            TodoCategories: {
                GetAll: BASE_URL_TRADE_POINTS + "/Client/TodoCategories",
                PostUpdate: BASE_URL_AUDITS + "/Client/UpdateTodo"
            },           
             

            GetSegments: BASE_URL + "/Client/TradePoints/GetSegments",
            GetSegment: BASE_URL + "/Client/TradePoints/GetSegment"          
        },
        
        Users: {
            GetCenter: BASE_URL_USERS + "/Center",
            GetBranches: BASE_URL_USERS + "/Client/Branches",
            GetSubordinatesEmployees: BASE_URL_USERS + "/Client/Subordinates"
        },

        Settings: {
            PostSave: BASE_URL_USERS + "/SaveSettings",
            Get: BASE_URL_USERS + "/GetSettings"  
        },

        Photos: {
            PostUpdate: BASE_URL_PHOTOS + "/Client/Upload",
            GetCategories: BASE_URL_PHOTOS + "/Client/Categories"
        }
    },

    Admin: {

        Tags: {

            StandardsBook: {
                PostEdit: BASE_URL_STANDARDS_BOOK + "/Admin/Tags/Edit",
                PostDelete: BASE_URL_STANDARDS_BOOK + "/Admin/Tags/Delete",
                PostUpdateSorting: BASE_URL_STANDARDS_BOOK + "/Admin/Tags/UpdateSorting",

                GetTag: BASE_URL_STANDARDS_BOOK + "/Admin/Tags/Info",
                GetTags: BASE_URL_STANDARDS_BOOK + "/Admin/Tags",
                GetAllInfo: BASE_URL_STANDARDS_BOOK + "/Admin/Tags/GetAllInfo"
            },

            Activities: {
                PostUpdate: BASE_URL_ACTIVITIES + "/Admin/Tags/Update",
                PostDelete: BASE_URL_ACTIVITIES + "/Admin/Tags/Delete",
                PostUpdateSorting: BASE_URL_ACTIVITIES + "/Admin/Tags/UpdateSorting",

                GetTag: BASE_URL_ACTIVITIES + "/Admin/Tags/Info",
                GetTags: BASE_URL_ACTIVITIES + "/Admin/Tags",
                GetAllInfo: BASE_URL_ACTIVITIES + "/Admin/Tags/getallinfo",
                GetParentTags: BASE_URL_ACTIVITIES +"/Admin/Tags/GetParentTags"
            }
          
        },

        SubSections: {
            PostUpdate: BASE_URL_ACTIVITIES + "/Admin/SubSections/Update",
            GetSubSections: BASE_URL_ACTIVITIES + "/Admin/SubSections"
        },

        StandardBooks: {
            PostUpdate: BASE_URL_STANDARDS_BOOK + "/Admin/Edit",
            PostDelete: BASE_URL_STANDARDS_BOOK + "/Admin/Delete",

            Get: BASE_URL_STANDARDS_BOOK + "/Admin/Edit",
            GetAll: BASE_URL_STANDARDS_BOOK + "/Admin",

            GetAllInfo: BASE_URL_STANDARDS_BOOK + "/Admin/Tags/GetAllInfo"
        },

        Questions: {
            // PostUpdate: BASE_URL + "Admin/QuestionsV2/Update",
            // PostRemove: BASE_URL + "Admin/QuestionsV2/Remove",
            // GetInfo: BASE_URL + "Admin/QuestionsV2/GetQuestionInfo",
            // GetActiveQuestions: BASE_URL + "Admin/QuestionsV2/GetActiveQuestions",
            // GetBranches: BASE_URL + "Admin/QuestionsV2/GetBranches",
            // GetSubQuestions: BASE_URL + "Admin/QuestionsV2/GetSubQuestions",

            //-------------------- N E W -----------------------
            PostUpdate: BASE_URL_ACTIVITIES + "/Admin/Questions/Update",
            PostDelete: BASE_URL_ACTIVITIES + "/Admin/Questions/Delete",
            Get: BASE_URL_ACTIVITIES + "/Admin/Questions/Info",
            GetQuestions: BASE_URL_ACTIVITIES + "/Admin/Questions",

            GetAll: BASE_URL_ACTIVITIES + "/Admin/Questions/GetAll",
            GetAllOptions: BASE_URL_ACTIVITIES + "/Admin/Questions/Options/GetAll"
        },

        Blocks: {
                      
            PostCopyBlock: BASE_URL + "/Admin/BlocksV2/CopyBlock",

            PostUpdate: BASE_URL_ACTIVITIES + "/Admin/Blocks/Update",
            PostDelete: BASE_URL_ACTIVITIES + "/Admin/Blocks/Delete",
            Get: BASE_URL_ACTIVITIES + "/Admin/Blocks/Info",
            GetAll: BASE_URL_ACTIVITIES + "/Admin/Blocks"

        },

        Branches: {
            PostUpdateSorting: BASE_URL_USERS + "/Admin/Branches/UpdateSorting",
            Get: BASE_URL_USERS + "/Admin/Branches/Info",
            GetAll: BASE_URL_USERS + "/Admin/Branches",
            GetTerritorialLinks: BASE_URL_USERS + "/Admin/Branches/TerritorialLinks"
        },

        Audits: {
            GetForUser: BASE_URL + "/Admin/Audits/ForUser",
            
            Get: BASE_URL + "/Admin/Audits/Get",
            PostResend: BASE_URL + "/Admin/Audits/ResendAudit",

            GetUsers: BASE_URL_USERS + "/Admin/UserInfoForFindAudits",
            GetUserAuditInfos: BASE_URL_AUDITS + "/Admin/GetUserAuditInfos",
            GetUserAuditData: BASE_URL_AUDITS + "/Admin/GetUserAuditData",
            GetAuditDax: BASE_URL_AUDITS + "/Dax/GetAudit",
            OpenClosed: BASE_URL_AUDITS + "/Admin/OpenClosed",
            GetFutureAudits: BASE_URL_AUDITS + "/Admin/GetFuture",
            GetAuditLink: BASE_URL_AUDITS + "/Dax/GetUrlForDownloadAudit",

            ResendAudit: BASE_URL_AUDITS + "/Admin/Redispatch"
        },

        Activities: {
            PostUpdate: BASE_URL_ACTIVITIES + "/Admin/Update",
            PostDelete: BASE_URL_ACTIVITIES + "/Admin/Delete",

            Get: BASE_URL_ACTIVITIES + "/Admin/Info",
            GetAll: BASE_URL_ACTIVITIES + "/Admin"
            
        },

        Users: {
            PostUpdate: BASE_URL_USERS + "/Admin/Update",
            PostSendPush: BASE_URL_USERS + "/Admin/SendPush",
            PostCreate: BASE_URL_USERS + "/Admin/Create",
            PostDelete: BASE_URL_USERS + "/Admin/Delete",

            Get: BASE_URL_USERS + "/Admin/Info",
            GetAll: BASE_URL_USERS + "/Admin",
            GetCheckIsDaxUser: BASE_URL_USERS + "/Admin/CheckIsDaxUser",
            GetUserRoutes: BASE_URL_USERS + "/Admin/Routes"
        },
        
        MobileVersions: {
            PostDelete: BASE_URL_USERS + "/Admin/MobileVersions/Delete",
            PostDeleteRange: BASE_URL_USERS + "/Admin/MobileVersions/DeleteRange",
            PostUpdate: BASE_URL_USERS + "/Admin/MobileVersions/Update",

            GetAll: BASE_URL_USERS + "/Admin/MobileVersions"
        },

        MmlCategories: {
            PostUpdate: BASE_URL_TRADE_POINTS + "/Admin/MmlInfo/Update",
            PostDelete: BASE_URL_TRADE_POINTS + "/Admin/MmlInfo/Delete",

            Get: BASE_URL_TRADE_POINTS + "/Admin/MmlInfo/Info",
            GetAll: BASE_URL_TRADE_POINTS + "/Admin/MmlInfo"
        },

        TradePoints: {
            PostDelete: BASE_URL + "/Admin/TradePoints/Delete",
            PostRestore: BASE_URL + "/Admin/TradePoints/Restore",
            GetFind: BASE_URL + "/Admin/TradePoints/Find",

            GetNetworks: BASE_URL_TRADE_POINTS + "/Admin/Networks"
        },

        Tma: {
            GetDaxTtIds: BASE_URL_TRADE_POINTS + "/Admin/Tma/GetDaxTtIds",
            GetForDaxTtId: BASE_URL_TRADE_POINTS + "/Admin/Tma/ForDaxTtId"
        },

        TodoCategories: {
            PostUpdateSorting: BASE_URL_TRADE_POINTS + "/Admin/UpdateSorting",
            PostDelete: BASE_URL_TRADE_POINTS + "/Admin/Delete",
            PostUpdate: BASE_URL_TRADE_POINTS + "/Admin/Update",

            GetAll: BASE_URL_TRADE_POINTS + "/Admin",
            Get: BASE_URL_TRADE_POINTS + "/Admin/Info"
        },

        PhotoCategories: {
            PostUpdate: BASE_URL_PHOTOS + "/Admin/PhotoCategories/Update",
            PostUpdateSorting: BASE_URL_PHOTOS + "/Admin/PhotoCategories/UpdateSorting",
            PostDelete: BASE_URL_PHOTOS + "/Admin/PhotoCategories/Delete",

            GetAll: BASE_URL_PHOTOS + "/Admin/PhotoCategories",
            Get: BASE_URL_PHOTOS + "/Admin/PhotoCategories/Info"
        },

        Aep: {
            PostDelete: BASE_URL + "Admin/AepEntries/Delete",
            GetTradePointsList: BASE_URL + "Admin/AepEntries/TradePoint/List",
        },

        ToDos: {
            PostDelete: BASE_URL + "Admin/ToDos/Delete",
            PostRestore: BASE_URL + "Admin/ToDos/Restore",
            GetSearch: BASE_URL + "Admin/ToDos/Search",
        },

        Routes: {
            GetIndexInfo: BASE_URL + "Admin/Routes/IndexInfo",
            GetUsersRoutes: BASE_URL + "Admin/Routes/GetUsersRoutes",
            Get: BASE_URL + "Admin/Routes/GetRoute",
        },

        Contacts: {
            PostDelete: BASE_URL + "Admin/Contacts/Delete",
            PostRestore: BASE_URL + "Admin/Contacts/Restore",
            GetSearch: BASE_URL + "Admin/Contacts/Search",
        },

        MagnitAlerts: {
            GetForTradePoints: BASE_URL + "Admin/MagnitAlerts/ForTradePoints",
        },

        Cache: {
            PostActivitiesResetCache: BASE_URL_ACTIVITIES + "/Mobile/ResetCache",
            PostPhotosResetCache: BASE_URL_PHOTOS + "/Mobile/RemoveCache",
            PostStandartsBookResetCache: BASE_URL_STANDARDS_BOOK + "/Mobile/ResetCache",
            PostTodoCategoriesResetCache: BASE_URL_TRADE_POINTS + "/Mobile/Todos/RemoveCache"
        },

        Bot: {
            Filters: {
                GetAll: BASE_URL_TRADE_POINTS + "/Admin/BotForms/GetList",
                Get: BASE_URL_TRADE_POINTS + "/Admin/BotForms/ById",
                PostCreateOrUpdate: BASE_URL_TRADE_POINTS + "/Admin/BotForms/CreateOrUpdate",
                Delete: BASE_URL_TRADE_POINTS + "/Admin/BotForms/Delete",

                GetFormsLinks: BASE_URL_MAYTG + "/Admin/Forms/FormLinksWhereTradePointIsRequired"
            }
        }
    },

    Account: {
        PostTokenLogin: BASE_URL_USERS + "/tokenLogin",
        PostResetPassword: BASE_URL_USERS + "/ResetPassword",
        PostForgotPassword: BASE_URL_USERS + "/ForgotPassword",

        GetInfo: BASE_URL_USERS + "/Info"
    },

    

}